<script setup lang="ts">
import UiButton from '@/components/core/UiButton.vue';
import UiModal from '@/components/core/UiModal.vue';
import Events, { AppEvents } from '@/constants/Events';
import Icons from '@/constants/Icons';
import ModalNames from '@/constants/ModalNames';
import AppMessages from '@/models/core/AppMessages';
import { deleteByUid } from '@/services/foreman';
import { computed } from 'vue';
import { useVfm } from 'vue-final-modal';
import { useI18n } from 'vue-i18n';

const props = defineProps<{
  fullName: string;
  foremanUid: string;
}>();

const { t } = useI18n();
const { close } = useVfm();

const title = computed(() => t(`modalNames.${ModalNames.Foreman.Delete}`));

async function handleConfirm() {
  const { data } = await deleteByUid(props.foremanUid);

  if (data) {
    AppEvents.emit(Events.Foreman.Deleted, props.foremanUid);
    AppMessages.success(t('foremans.deleted', { fullName: props.fullName }));
    close(ModalNames.Foreman.Delete);
  }
}
</script>

<template>
  <UiModal :icon="Icons.Core.Delete" :modalId="ModalNames.Foreman.Delete" sizeClass="w-lg" :title>
    <div class="ui-bg-primary p-8 text-xl">
      {{ t('foremans.confirmDelete', { fullName }) }}
    </div>
    <template #actions>
      <UiButton primary @click="handleConfirm">{{ t('core.confirm') }}</UiButton>
      <UiButton @click="close(ModalNames.Foreman.Delete)">{{ t('core.cancel') }}</UiButton>
    </template>
  </UiModal>
</template>
